import { getRecordList } from '@src/utils/media-data';
import OptionalImage from '@src/components/optional-image';
import React, { useMemo } from 'react';
import { observer } from 'mobx-react';
import useStore from '@src/utils/hooks/use-store';
import cx from 'classnames';
import Part1Store from './store';
import BaseSwiper from '@src/components/swiper/base-swiper';
// import Link from '@src/components/link';

const styles = require('./index.less');

const Part1 = () => {
  const store = useStore(() => new Part1Store());
  // 公测活动swiper
  const activitySwiper = useMemo(
    () => {
      if (!getRecordList(store.activityData).length) return null;
      return (
        <div className={styles.activitySwiper}>
          <BaseSwiper store={store.activitySwiperStore}>
            {getRecordList(store.activityData).map((item, index) => (
              <div key={index} className={styles.activitySwiperItem}>
                <OptionalImage className={styles.activitySwiperItemImg} src={item.activityImg} alt={`activity-img-${index}`} />

                <div className={cx(styles.pos, { [styles.activities]: item.isActivities === 1 })}>
                  {/* <OptionalImage className={styles.title} src={item.desc} alt="标题" /> */}
                  {/* <OptionalImage
                    className={cx(styles.activitySubtitle, { [styles.add_height]: item.isActivities === 1 })}
                    src={item.activitySubtitle}
                    alt="兑换码信息\描述"
                  /> */}
                  {/*<div className={styles.exchangeBtn} onClick={() => store.onCopy(item.code)} alt="兑换按钮" data-id={'exchangeBtn'} data-exchange-code={item.code} />*/}
                  <div className={styles.exchangeBtn} alt="兑换按钮" data-id={'exchangeBtn'} data-exchange-code={item.code} />
                </div>
              </div>
            ))}
          </BaseSwiper>
        </div>
      );
    },
    [store.activityData]
  );
  // 公测活动tab
  const activityTab = useMemo(
    () => {
      if (!getRecordList(store.activityData).length) return null;
      return (
        <div className={styles.activityTab}>
          {getRecordList(store.activityData).map((item, index) => (
            <div
              key={index}
              className={cx(styles.activityTabItem, index === store.activitySwiperStore.activeIndex && styles.activityTabItemActive)}
              onClick={() => store.onChangeActivityIndex(index)}
            >
              <OptionalImage
                src={index === store.activitySwiperStore.activeIndex ? item.activeTabImg : item.tabImg}
                alt={`activity-tab-img-${index}`}
                className={cx(styles.activityTabItemImg, index === store.activitySwiperStore.activeIndex && styles.activityTabItemImgActive)}
              />
            </div>
          ))}
        </div>
      );
    },
    [store.activityData, store.activitySwiperStore.activeIndex]
  );
  return (
    <div className={styles.part1Root}>
      <div className={styles.part1Title} />
      {activitySwiper}
      {activityTab}
    </div>
  );
};

export default observer(Part1);
